// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getScanForm: "/scan_form/get_scan_form_list",
    getScanFormAvailable: "/scan_form/get_usps_b_shipments",
    //
    createScanForm: "/scan_form/create_scan_form",
    printScanForm: "/scan_form/print"
};

// ----------------------------------------------------------------------

const printScanForm = (request, config) => axios.get(`${ API_ENDPOINTS.printScanForm }`, {
    params: {
        ...request
    },
    responseType: "blob",
    ...config
});

// ----------------------------------------------------------------------

const {
    useGetScanFormListQuery,
    //
    useGetScanFormAvailableListQuery,
    //
    useCreateScanFormMutation
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getScanFormList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "ScanFormList" ],
            query: (request) => `${ API_ENDPOINTS.getScanForm }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        //
        getScanFormAvailableList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "ScanFormAvailableList" ],
            query: () => `${ API_ENDPOINTS.getScanFormAvailable }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        //
        createScanForm: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.createScanForm }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "ScanFormList", "ScanFormAvailableList" ]
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    printScanForm as printScanFormAPI,
    //
    useGetScanFormListQuery,
    //
    useGetScanFormAvailableListQuery,
    //
    useCreateScanFormMutation
};
